import { render } from "./polkaWallet.vue?vue&type=template&id=4bde9e0b&scoped=true"
import script from "./polkaWallet.vue?vue&type=script&lang=js"
export * from "./polkaWallet.vue?vue&type=script&lang=js"

import "./polkaWallet.vue?vue&type=style&index=0&id=4bde9e0b&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bde9e0b"]])

export default __exports__